import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ItemForm from './items/ItemForm';
import Item from '../../../models/Item';
import { updateItem } from '../../../redux/ducks/items';
import { fetchCollections } from '../../../redux/ducks/collections';
import pageWrapper from '../../containers/MainPage';
import slugger from '../../../slugger';
import Loading from '../../common/Loading';
import Breadcrumbs from '../../common/Breadcrumbs';
import { getItemType } from '../../../config/constants';

class EditItemPage extends Component {
  componentDidMount() {
    if (!this.props.item) {
      // Direct navigation, load all items first
      this.props.getCollections();
    }
  }

  handleSubmit = (item, onSuccess, onFailure) => {
    const { history, onSubmit } = this.props;
    const successRedirect = (newItem) => {
      onSuccess();
      const [subcatType, subcatKey] = newItem.getSubcategoryTypeAndKey();
      history.push(`/collections/${newItem.category}/${subcatType}/${slugger(subcatKey)}/${newItem.id}`);
    };
    onSubmit(item, successRedirect, onFailure);
  };

  render() {
    const { item } = this.props;

    if (!item) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <Breadcrumbs
          segments={[
            { label: 'Collections', linkTo: '/collections' },
            { label: getItemType(item.category), linkTo: `/collections/${getItemType(item.category)}` },
            {
              label: item.getSubcategoryTypeAndKey()[1],
              linkTo: item.getPermalink().replace(/\/\d*$/, ''),
            },
            { label: item.itemData.title, linkTo: item.getPermalink() },
            { label: 'Edit' },
          ]}
        />

        <ItemForm item={item} onSubmit={this.handleSubmit} />
      </React.Fragment>
    );
  }
}

EditItemPage.propTypes = {
  item: PropTypes.instanceOf(Item),
  getCollections: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

EditItemPage.defaultProps = {
  item: null,
};

function mapStateToProps(state, ownProps) {
  const givenId = parseInt(ownProps.match.params.itemId, 10);

  return {
    location: ownProps.match,
    item: state.collections.items.find(i => i.id === givenId),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (item, onSuccess, onFailure) => {
      dispatch(updateItem(item, onSuccess, onFailure));
    },
    getCollections: () => {
      dispatch(fetchCollections());
    },
  };
}

export default pageWrapper(connect(mapStateToProps, mapDispatchToProps)(EditItemPage), 'Edit Item');



// WEBPACK FOOTER //
// ./src/components/pages/collections/EditItemPage.jsx